"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importDefault(require("react"));
var LoginGiftcodeBonus_1 = __importDefault(require("../../common/LoginGiftcodeBonus"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LogInBonusCongrats = function () {
    var t = (0, next_intl_1.useTranslations)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var giftcodeParam = searchParams.get('giftcode');
    var backUrl = searchParams.get('back');
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var onClick = function () {
        return router.push(backUrl
            ? backUrl
            : generateUrlWithLang("/account/bonuses/cash?giftcode=".concat(giftcodeParam)));
    };
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "460px", height: "auto", portalNodeId: "modal", saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t('loginGiftcodeBonus.congratsTitle'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('loginGiftcodeBonus.congratsText')),
            react_1.default.createElement(LoginGiftcodeBonus_1.default, null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "primary", onClick: onClick }, t('translation.useBonus')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.cancelBonus, onClick: onClick }, t('translation.useAnotherBonus'))))));
};
exports.default = LogInBonusCongrats;
